import React from 'react';
import Avatar from 'shared/components/avatar/Avatar';
import { firstLetters } from 'utils/strings';
import { Link } from 'react-router-dom';

const ItemGoal = props => {
  const {
    avatarImage,
    name,
    period,
    avatarUrl,
    clientId,
    title,
    message
  } = props;

  return (
    <div className="timeline-item">
      <Avatar
        src={avatarImage}
        width="32"
        height="32"
        name={name}
        text={`${period} ago`}
        firstLetters={firstLetters(name)}
        url={avatarUrl}
      />
      <div className="activity-info">
        <Link to={`/clients/${clientId}/goals/new`}>{title}</Link>
        {
          message.split('\n')?.map(goal => {
            return <p key={goal} className="timeline-content">{goal}</p>
          })
        }
      </div>
    </div>
  );
};

export default ItemGoal;
